import { Topics } from './topics';

/**
 * @deprecated Use ICommand instead.
 */
export abstract class IUntypedCommand {
    public static readonly TOPIC: Topics;
}

/**
 * Use in conjuction with ICommandHandler.
 */
export abstract class ICommand<ReturnType = any> {
    public static readonly TOPIC: Topics;

    /**
     * Will never be assigned or used as a value.
     * Only used to infer the return type of the command.
     * @internal
     */
    readonly returnType?: ReturnType;
}

// Helper type to extract return type excluding undefined but preserving null
type CommandResult<T extends ICommand<any>> = T extends ICommand<infer R> ? R : never;

/**
 * Enforces return types of handler to correspond with that of the command.
 */
export interface ICommandHandler<T extends ICommand<any>> {
    handle(q: T): Promise<CommandResult<T>>;
}
